module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-carousel', _vm._l((_vm.carousels), function(carousel, i) {
    return _c('b-carousel-item', {
      key: i
    }, [_c('section', {
      class: ("hero is-medium is-" + (carousel.color))
    }, [_c('div', {
      staticClass: "hero-body has-text-centered"
    }, [_c('h1', {
      staticClass: "title"
    }, [_vm._v(_vm._s(carousel.text))])])])])
  }), 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9dd11764"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./docs/pages/components/carousel/examples/ExSimple.vue
// module id = 979
// module chunks = 3 162